import Loading from "components/common/Loading";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import hubLayout from 'styles/css/hubLayout.module.css';
import ReactDatePicker from "react-datepicker";
import { ko } from "date-fns/locale";
import 'react-datepicker/dist/react-datepicker.css';
import { afterServiceStateType, calculDayDateToString, afterServiceType, formatDateToString, formattedDateTime, getCurrentDateTime } from "pages/utils/commonUtils";
import styled from "styled-components";
import { IoAdd } from "react-icons/io5";
import { OutlinePrimaryPinkButton, PrimaryButton } from "components/common/Button";
import { AfterService, Recorder } from "type/type";
import { createAfterService, decryptAES256, getAfterServiceAll, getRecorderList, maxLengthCheck, putAfterService, updateAfterServiceState } from "api/api";
import { UserLoginInfoContext } from "pages/Layout";
import { useModal } from "components/common/ModalLayout";

// 상단 날짜 filter
const SearchDateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 0.5rem;
  border-bottom: 1px solid #e7e7e7;
  > div {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  > div:first-of-type > div {
    max-width: 250px;
  }
  .react-datepicker-wrapper {
    width: 100%;

    // 달력 표시 input
    input[type="text"] {
      height: auto;
      padding: 0.5rem;
      text-align: center;
    }
    
    .react-datepicker__close-icon {
      padding-right: 0.5rem;
    }
  }
  
  // ReactDatePicker
  .react-datepicker__triangle {
    display: none;
  }
  .react-datepicker {
    .react-datepicker__current-month,
    .react-datepicker,
    .react-datepicker__today-button,
    .react-datepicker__header {
      background-color: #fdfdfd;
    }

    left: 40px;
    // 선택 범위 date
    .react-datepicker__day.react-datepicker__day--in-range {
      background-color: #1568dd;
      opacity: 0.6;
      &:hover {
        opacity: 1;
      }
    }
    .react-datepicker__day.react-datepicker__day--range-start {
      background-color: #1568dd;
      color: white;
      opacity: 0.3;
    }
    .react-datepicker__day.react-datepicker__day--range-end {
      background-color: #1568dd;
      opacity: 1;
    }
    // 날짜 선택 중인 범위 date
    .react-datepicker__day.react-datepicker__day--in-selecting-range {
      background-color: #e4007f;
      opacity: 0.6;
    }
    .react-datepicker__day.react-datepicker__day--selecting-range-start {
      background-color: #e4007f;
      opacity: 0.3;
    }
    .react-datepicker__day.react-datepicker__day--selecting-range-end {
      background-color: #e4007f;
      opacity: 1;
    }
    .react-datepicker__day--outside-month {
      color: #bdbdbd;
    }
  }
  
  button[data-select-icon="true"] {
    background-color: #1568dd;
    color: white;
  }
  button[data-select-icon="false"] {
    background-color: inherit;
    color: #1568dd;
  }

  input:focus-visible {
    outline-color: #1568dd;
  }

  button {
    padding: 0.5rem 0.3rem;
  }
`;

const CreateSection = styled.div`
  .create_content {
    padding: 0.75rem 0;
  }
  
  .info_wrap,
  .button_wrap {
    padding: 0.75rem 0.5rem;
  }
  
  .info_title {
    font-size: 1.125rem;
    margin-bottom: 1rem;
    padding: 0.5rem 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    border-bottom: 1px solid #121212;

    p {
      font-size: 0.75rem;
    }
    span:first-of-type {
      color: #e4007f;
      line-height: 1;
      padding-right: 0.25rem;
    }
  }
  
  .info_content {
    label {
      width: 8rem;
      font-size: 14px;
      font-weight: 600;
      color: #262626;
    }
    
    .type_wrap  {
      flex-wrap: wrap;
      row-gap: 0.5rem;

      div {
        min-width: 4rem;
        margin-right: 1rem;
      }
      label {
        margin-left: 0.5rem;
        font-weight: 400;
      }
    }
    
    .readonly_info input,
    input[name="privacyCheck"] ~ label {
      width: calc(100% - 5rem - 1rem);
    }
    input {
      width: 100%;
      border: none;
      border-radius: 0;
      border-bottom: 1px solid #e7e7e7;
      &:focus,
      &:focus-visible {
        outline: none;
        border-bottom: 1px solid #1568dd;
      }
    }
    textarea {
      width: 100%;
      border-radius: 0.25rem;
      max-height: 80px;
      
      &:focus,
      &:focus-visible {
        outline: none;
        border: 1px solid #1568dd;
      }
    }

    input:read-only {
      cursor: default;
      border: none;

      &:focus-visible {
        outline: none;
      }
    }

    input[type="radio"],
    input[type="checkbox"] {
      appearance: none;
      width: 0.875rem;
      height: 0.875rem;
      border-radius: 0.25rem;
      border: 1px solid #1568dd;
      &:checked {
        background-color: #1568dd;
      }
    }

    .select-wrap {
      position: relative;
      min-width: 150px;
      max-width: 400px;
      width: 100%;

      select {
        border: 1px solid #e7e7e7;
        padding: 0 1rem;
        border-radius: 0.25rem;
  
        &:focus,
        &:focus-visible {
          outline: none;
          border-color: #1568dd;
        }
      }
      &::after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        top: 50%;
        right: 20px;
        border: 5px solid transparent;
        border-top-color: #e7e7e7;
        transform: scaleY(1.4);
      }
      &::before {
        content: '';
        position: absolute;
        display: block;
        width: 1px;
        height: 95%;
        top: 0;
        right: 48px;
        background-color: #e7e7e7;
        z-index: 0;
      }
    }
  }
  }
  .info_content {
    > div {
      position: relative;
      padding-left: 1rem;

      &:not(:last-of-type) {
        margin-bottom: 0.5rem;
      }
    }
    
    &:not(.readonly_info) > div {
      row-gap: 1rem;
    }
    
    .limit_text {
      text-align: right;
      margin-top: -0.5rem;
      
      span:first-of-type {
        color: #e4007f;
        font-weight: 600;
      }
    }
  }

  .readonly_info span {
    width: 100%;
    padding: 13px 20px;
    font-size: 14px;
    line-height: 20px;
    color: #666;
    white-space: pre-wrap;
    word-break: break-all;
    overflow-wrap: break-word;
  }

  .button_wrap {
    margin-top: 1rem;
    div {
      column-gap: 0.5rem;
    }
    
    button {
      flex-grow: 1;
      line-height: 1.5;
    }
  }

  .required::after {
    position: absolute;
    content: "*";
    color: #e4007f;
    margin-left: 0.25rem;
  }
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
`;


dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Seoul');

type AsQueryParams = {
  id: string | null;
  start_date: string | null;
  end_date: string | null;
};

// 사용자 A/S 접수 목록
export function UserAfterService() {
  // ****************************** 1. props, hook
  const navigate = useNavigate();
  const { userLoginInfo } = useContext(UserLoginInfoContext);

// ****************************** 2. state
  const [loading, setLoading] = useState(true);

  const sevenDaysAgo = new Date(calculDayDateToString(new Date(), -7));
  const defaultProps: AsQueryParams = {
    id: userLoginInfo ? userLoginInfo.id : 'x',
    start_date: formatDateToString(sevenDaysAgo),
    end_date: formatDateToString(new Date()),
  };

  const [queryParams, setQueryParams] = useState<AsQueryParams>(defaultProps);
  const [totalCount, setTotalCount] = useState(-1);
  const [asList, setAsList] = useState<AfterService[]>([]);
  const [clickIcon, setClickIcon] = useState(""); // 클릭한 기간 icon

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>(() => {
    const start = sevenDaysAgo;
    const end = new Date();
    return [start, end];
  });

  // ****************************** 3. API
  const fetchASList = async () => { 
    try {
      const asRes = await getAfterServiceAll(0, 0, queryParams);
      if (asRes.code === 200) {
        const sortedList = asRes.data.sort((a: AfterService, b: AfterService) => 
          dayjs(b.create_date).valueOf() - dayjs(a.create_date).valueOf()
        );
        setAsList(sortedList);
        setTotalCount(asRes.total_count);
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setLoading(false);
    }
  };

  // ****************************** 4. Event Handlers
  const handleChangeDate = ([startDate, endDate]: [Date | null, Date | null]) => {
    setClickIcon("");
    setDateRange([startDate, endDate]);

    setQueryParams((prev) => ({
      ...prev,
      start_date: startDate ? formatDateToString(startDate) : "",
      end_date: endDate ? formatDateToString(endDate) : "",
    }));
  }

  // 3/6/12개월 기간 변경
  const changeDateRange = (month: string) => {
    setClickIcon(month);
    
    const today = new Date();
    const lastDateMonth = new Date();
    
    const monthNum = month === "curr" ? 0 : month === "prev" ? 1 : Number(month.replace("month", "")) - 1;
    lastDateMonth.setMonth(today.getMonth() - monthNum);
    
    const start_date = formatDateToString(new Date(lastDateMonth.getFullYear(), lastDateMonth.getMonth(), 1));
    const end_date = month === "prev"
      ? formatDateToString(new Date(lastDateMonth.getFullYear(), lastDateMonth.getMonth() + 1, 0))
      : formatDateToString(new Date(today.getFullYear(), today.getMonth() + 1, 0));
    
    setDateRange([new Date(start_date), new Date(end_date)]);
    setQueryParams((prev) => ({ ...prev, start_date, end_date }));
  };

  // ****************************** 5. useEffect
  useEffect(() => {
    fetchASList();
  }, [queryParams]);
  return (
    <>
      {loading ? <Loading /> : 
        <>
          <div className={`${hubLayout.cnt_box}`} style={{overflowY: "auto", height: "100%"}}>
            <div className={`${hubLayout.acc__cnt}`}>
              {/* <div className={`${hubLayout.sec_title} ${hubLayout.fixed_title}`}>
                <h2>공지사항</h2>
                <span onClick={() => navigate(-1)}>X</span>
              </div> */}
              <p className={`${hubLayout.acc_total}`} style={{ margin: '0.5rem 0 0 0' }}>총 <strong className={`${hubLayout.tx_blue}`}>{totalCount}</strong>개</p>
              {/* 기간 조회 */}
              <SearchDateContainer>
                <div>
                  <div>
                    <ReactDatePicker
                      locale={ko} // 언어
                      disabledKeyboardNavigation // 다른 달에서도 오늘 날짜 강조 제거
                      dateFormat="yy.MM.dd" // 날짜형태
                      todayButton="오늘"
                      minDate={new Date("2024-01-01")}
                      maxDate={new Date()}
                      selectsRange={true}
                      startDate={dateRange[0]}
                      endDate={dateRange[1]}
                      onChange={(update) => handleChangeDate(update)}
                      calendarClassName="custom-calendar"
                      isClearable={false}
                    />
                  </div>
                  <div className={`${hubLayout.flex_box}`} style={{gap: '0.3rem'}}>
                    {/* 기간은 추후 수정 - 전달값도 변경하면 됩니다.*/}
                    <button type="button" className={`${hubLayout.range_icon}`} data-select-icon={clickIcon === "6month"} onClick={() => changeDateRange("6month")}>6개월</button>
                    <button type="button" className={`${hubLayout.range_icon}`} data-select-icon={clickIcon === "prev"} onClick={() => changeDateRange("prev")}>지난달</button>
                    <button type="button" className={`${hubLayout.range_icon}`} data-select-icon={clickIcon === "curr"} onClick={() => changeDateRange("curr")}>이번달</button>
                  </div>
                </div>
              </SearchDateContainer>
              {/* 접수한 A/S 목록 */}
              <div className={`${hubLayout.acc_total}`} style={{ margin: '0rem', textAlign: 'center', borderBottom: 'none'}}>
                {asList.length === 0 ?
                  <li className={`${hubLayout.acc_item}`}>
                    <div className={`${hubLayout.acc_item_info}`}>
                      <dl>
                        <dd style={{ textAlign: "center" }}>접수된 A/S가 없습니다.</dd>
                      </dl>
                    </div>
                  </li>
                  :
                  asList.map((as, index) =>
                    <li key={`notice_${index}`} className={`${hubLayout.list_item}`}>
                      <div className={`${hubLayout.list_info}`} onClick={()=> navigate(`/user/after-service/detail/${as.idx}`, {state: as})}>
                        {/* 제목, 상태, 등록일, 문의유형 */}
                        <div className={`${hubLayout.list_info_top}`}>
                          <dl>
                            <dd>{as.as_type}</dd>
                          </dl>
                          <dl className={`${hubLayout.state_icon}`}>
                            <dd data-state={`state_${as.state}`}><span>{afterServiceStateType[(as.state)]}</span></dd>
                          </dl>
                        </div>
                        <div className={`${hubLayout.list_info_bottom}`}>
                          <dl className={`${hubLayout.ellipsis_text_wrap}`}>
                            <dd className={`${hubLayout.ellipsis_text}`}>{as.title}</dd>
                          </dl>
                          <dl>
                            <dt style={{fontSize: '12px', color: '#a9a9a9'}}>{formattedDateTime(as.create_date)}</dt>
                          </dl>
                        </div>
                      </div>
                    </li>
                  )
                }
              </div>
              <button type="button" className={`${hubLayout.floating_button}`} onClick={() => navigate(`/user/after-service/create`)}>
                <IoAdd />
              </button>
            </div>
          </div>
        </>
      }
    </>
  );
}

// 고객 A/S 접수
export function UserAfterServiceCreate() {
  // ****************************** 1. props, hook
  const navigate = useNavigate();
  const { userLoginInfo } = useContext(UserLoginInfoContext);

  const { state } = useLocation();
  const { showModal } = useModal();
  // ****************************** 2. state
  const [loading, setLoading] = useState(true);

  const currentDateTime = getCurrentDateTime();
  const [asData, setAsData] = useState<AfterService>(state || {
    idx: 0,
    user_id: userLoginInfo ? userLoginInfo.id : 'x', // Layout 완성 된 후 변경 예정
    user_name: userLoginInfo ? userLoginInfo.name : 'x', // Layout 완성 된 후 변경 예정
    user_mobile: '',
    user_email: '',
    title: '',
    content: '',
    reg_name: '',
    model: '',
    state: 0,
    as_type: 'APP',
    answer_type: 'Mobile',
    create_date: currentDateTime,
    update_date: currentDateTime,
  });
  const [recorderList, setRecorderList] = useState<Recorder[]|[]>([]);

  // 개인정보 수집 동의 체크박스
  const [privacyCheck, setPrivacyCheck] = useState(false);
  // 유효성 검사
  const TITLEMAXLENGTH = 50;
  const CONTENTMAXLENGTH = 500;
  const [titleLength, setTitleLength] = useState(0);
  const [contentLength, setContentLength] = useState(0);
  const [valid, setValid] = useState(false);

  // ****************************** 3. api
  const mainApi = async () => { 
    setLoading(true);
    try {
      // Recorder 데이터 조회
      const recorderRes = await getRecorderList(0, 0, { user_id: asData.user_id });
      // Recorder 목록 설정
      if (recorderRes.code === 200) {
        setRecorderList(recorderRes.data);
      }
    } catch (error) {
      console.error("error ", error);
    } finally {
      setTitleLength(asData.title.length);
      setContentLength(asData.content.length);
      setLoading(false);
    }
  }

  // ****************************** 4. event handler
  
  // 설치위치 변경
  const handleRegNameChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedRegName = event.target.value;

    const selectedRecorder = recorderList.find(
      (recorder) => recorder.reg_name === selectedRegName
    );

    if (selectedRecorder) {
      setAsData((prev) => ({
        ...prev,
        reg_name: selectedRecorder.reg_name,
        model: selectedRecorder.model || '',
      }));
    }
  };

  // 문의 유형 변경
  const handleTypeChange = (event: any) => {
    const { name, value } = event.target;
    setAsData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // input 내용 변경
  const handleChange = (event: any) => {
    const { name, value } = event.target;
    maxLengthCheck(event);
    // 연락처
    if (name === "user_mobile") {
      const user_mobile = value.replace(/\D/g, '');
        if (user_mobile.length <= 11) {
          setAsData(prev => ({...prev, user_mobile})); // 상태 업데이트
        }
    }
    else {
      setAsData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // 제목 변경
  const handleTitleChange = (value: string) => {
    const length = value.length;
    if (length <= TITLEMAXLENGTH) {
      setAsData((prev) => ({
        ...prev,
        title: value,
      }));
      setTitleLength(length);
    }
  };
  // 내용 변경
  const handleContentChange = (value: string) => {

    const length = value.length;
    if (length <= CONTENTMAXLENGTH) {
      setAsData((prev) => ({
        ...prev,
        content: value,
      }));
      setContentLength(length);
    }
  };

  // 필수항목이 다 입력 됐는지 유효성 검사
  const checkVaild = () => {
    const { title, content, reg_name, as_type, answer_type, user_mobile, user_email } = asData;
    
    const requiredFields = [
      title,
      content,
      reg_name,
      as_type,
      (answer_type === "Mobile" ? user_mobile : answer_type === "Email" ? user_email : true),
      privacyCheck
    ];
    
    // 모든 필드가 true인지 체크
    return requiredFields.every(field => field);
  }


  // A/S 등록
  const setAfterService = async () => {
    const response = state ? await putAfterService(asData) : await createAfterService(asData);
    if (response.code === 200) {
      showModal("alert", state ? "A/S정보가 수정되었습니다." : "A/S가 접수되었습니다.", { confirm: true, cancel: true },
        () => navigate(`/user/after-service/list`),
        () => navigate(`/user/after-service/list`)
      );
    } else {
      showModal("alert", response.message);
    }
  }
  // ****************************** 5. useEffect

  useEffect(() => {
    mainApi();
  }, []);

  useEffect(() => {
    const isValid = checkVaild();
    setValid(isValid);
  }, [asData, privacyCheck]);
  return (
    <>
      {loading ? <Loading /> : 
        <>
          <CreateSection style={{ overflowY: "auto", height: "100%" }}>
            <div className={`${hubLayout.acc__cnt}`}>
              <h2 className={`${hubLayout.cnt_title}`} style={{lineHeight: '1.5rem'}}>A/S 접수</h2>
              <div className="create_content">
                <div className="info_wrap">
                  <div className="info_title">
                    <h4>1. 내 정보</h4>
                  </div>
                  <div className="info_content readonly_info">
                    <FlexRow>
                      <label>성명</label>
                      <input type="text" name="user_name" value={asData.user_name} readOnly />
                    </FlexRow>
                    <FlexRow>
                      <label>아이디</label>
                      <input type="text" name="user_id" value={asData.user_id} readOnly />
                    </FlexRow>
                  </div>
                </div>
                <div className="info_wrap">
                  <div className="info_title">
                    <h4>2. 문의 유형 선택</h4>
                    <p><span>*</span><span>필수입력</span></p>
                  </div>
                  <div className="info_content">
                    <FlexCol>
                      <label className="required">문의 유형</label>
                      <FlexRow className="type_wrap">
                        {afterServiceType.map((type: string, index: number) => 
                          <div key={`afterServiceType_${index}`}>
                            <input
                              type="radio"
                              name="as_type"
                              id={`as_type_${index}`}
                              value={type}
                              checked={asData.as_type === type}
                              onChange={handleTypeChange}
                            />
                            <label htmlFor={`as_type_${index}`}>{type}</label>
                          </div>
                        )}
                      </FlexRow>
                    </FlexCol>
                  </div>
                </div>
                <div className="info_wrap">
                  <div className="info_title">
                    <h4>3. 제품 선택</h4>
                    <p><span>*</span><span>필수입력</span></p>
                  </div>
                  <div className="info_content">
                    <FlexCol>
                      {/* 설치 위치 type 및 항목에 따라 input 또는 select로 진행 */}
                      <label className="required">설치 위치</label>
                      
                      {recorderList.length === 0 ? (
                        <input
                          type="text"
                          value={asData.reg_name}
                          placeholder="설치 위치를 입력해주세요."
                          maxLength={50}
                          name="reg_name"
                          onChange={handleChange}
                        />
                      ) : (
                        <div className="select-wrap">
                          <select
                            name="reg_name"
                            value={asData.reg_name}
                            onChange={handleRegNameChange}
                          >
                            <option value="" disabled>
                              설치 위치를 선택해주세요
                            </option>
                            {recorderList.map((recorder, index) => (
                              <option key={index} value={recorder.reg_name}>
                                {recorder.reg_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                      {/* <input type="text" name="reg_name" value={asData.reg_name} onChange={handleChange} placeholder="설치 위치 입력" /> */}
                    </FlexCol>
                    <FlexCol>
                      <label>모델</label>
                      <input type='text' name="model" value={ asData.model } placeholder="모델을 입력해주세요." maxLength={20} onChange={handleChange} />
                    </FlexCol>
                  </div>
                </div>
                <div className="info_wrap">
                  <div className="info_title">
                    <h4>4. A/S 내용</h4>
                    <p><span>*</span><span>필수입력</span></p>
                  </div>
                  <div className="info_content">
                    <FlexCol>
                      <label className="required">제목</label>
                      <input type="text" name="title" value={asData.title} onChange={(e) => handleTitleChange(e.target.value)} placeholder="제목 입력" />
                      <p className="limit_text"><span>{titleLength}</span>/<span>{TITLEMAXLENGTH}</span>자</p>
                    </FlexCol>
                    <FlexCol>
                      <label className="required">내용</label>
                      <textarea name="content" value={asData.content} onChange={(e) => handleContentChange(e.target.value)} placeholder="내용 입력"></textarea>
                      <p className="limit_text"><span>{contentLength}</span>/<span>{CONTENTMAXLENGTH}</span>자</p>
                    </FlexCol>
                  </div>
                </div>
                <div className="info_wrap">
                  <div className="info_title">
                    <h4>5. 답변 방법 선택</h4>
                    <p><span>*</span><span>필수입력</span></p>
                  </div>
                  <div className="info_content">
                    <FlexRow className="type_wrap">
                      <div>
                        <input
                          type="radio"
                          name="answer_type"
                          id="answer_type_phone"
                          value={"Mobile"}
                          checked={asData.answer_type === "Mobile"}
                          onChange={handleTypeChange}
                        />
                        <label htmlFor="answer_type_phone">전화/문자</label>
                      </div>
                      {/* <div>
                        <input
                          type="radio"
                          name="answer_type"
                          id="answer_type_user_email"
                          value={"Email"}
                          checked={asData.answer_type === "Email"}
                          onChange={handleTypeChange}
                        />
                        <label htmlFor="answer_type_user_email">이메일</label>
                      </div> */}
                    </FlexRow>
                    {/* 전화/문자면 핸드폰 입력란, 이메일이면 이메일 입력란 보이기 */}
                    {asData.answer_type === "Mobile" ?
                      <FlexCol>
                        <label className="required">연락처</label>
                        <input type="text" name="user_mobile" value={asData.user_mobile} onChange={handleChange} placeholder="'-'없이 답변 받을 연락처 입력" />
                      </FlexCol>
                      :
                      <FlexCol>
                        <label className="required">이메일</label>
                        <input type="text" name="user_email" value={asData.user_email} onChange={handleChange} placeholder="답변 받을 이메일 입력" />
                      </FlexCol>
                    }
                  </div>
                </div>
                <div className="info_wrap">
                  <div className="info_title">
                    <h4>6. 개인정보 수집 동의</h4>
                    <p><span>*</span><span>필수입력</span></p>
                  </div>
                  <div className="info_content">
                    <FlexRow className="type_wrap">
                      <input
                        type="checkbox"
                        name="privacyCheck"
                        id="privacyCheck"
                        onChange={() => setPrivacyCheck(prev => !prev)}
                      />
                      <label htmlFor="privacyCheck" className="required" style={{fontSize: '1rem'}}>개인정보 수집 및 이용에 동의합니다.</label>
                    </FlexRow>
                  </div>
                </div>
                <div className="button_wrap">
                  <FlexRow>
                    <PrimaryButton type="button" disabled={!valid} onClick={setAfterService}>{state ? "수정" : "접수"}</PrimaryButton>
                    <OutlinePrimaryPinkButton type="button" onClick={() => navigate(`/user/after-service/list`)} >취소</OutlinePrimaryPinkButton>
                  </FlexRow>
                </div>
              </div>
            </div>
          </CreateSection>
        </>
      }
    </>
  );
}

export function UserAfterServiceDetail() {
  // ****************************** 1. props, hook
  const { state } = useLocation();
  const { showModal } = useModal();
  const REACT_APP_SECRET_KEY = process.env.REACT_APP_SECRET_KEY!;
  const REACT_APP_SECRET_IV = process.env.REACT_APP_SECRET_IV!;
  if (state.user_mobile && state.user_mobile.length > 11) {
    state.user_mobile = decryptAES256(state.user_mobile, REACT_APP_SECRET_KEY, REACT_APP_SECRET_IV)
  }

  const navigate = useNavigate();
  // ****************************** 2. state

  const [asData] = useState<AfterService>(state);

  // ****************************** 3. api

  // ****************************** 4. event handler
  // A/S 접수 취소
  const cancelAfterService = async () => {
    showModal("confirm", "접수를 취소하시겠습니까?", { confirm: false, cancel: false }, 
      async () => {
        asData.state = 5;
        const response = await updateAfterServiceState(asData);
        if (response.code === 200) {
          showModal("alert", "접수된 A/S가 취소되었습니다.", { confirm: true, cancel: true },
            () => navigate(`/user/after-service/list`), 
            () => navigate(`/user/after-service/list`)
          );
        } else {
          showModal("alert", response.message);
        }
      },
    );
  }
  return (
    <CreateSection style={{ overflowY: "auto", height: "100%" }}>
      <div className={`${hubLayout.acc__cnt}`}>
        <h2 className={`${hubLayout.cnt_title}`} style={{lineHeight: '1.5rem'}}>A/S 접수 현황</h2>
        <div className="create_content">
          <div className="info_wrap">
            <div className={`${hubLayout.state_icon}`}>
              <div data-state={`state_${asData.state}`} style={{textAlign: 'right'}}>
                <span>{afterServiceStateType[(asData.state)]}</span>
              </div>
            </div>
            <div className="info_title">
              <h4>1. 접수 상세 정보</h4>
            </div>
            <div className="info_content readonly_info">
              <FlexRow>
                <label>유형</label>
                <input type="text" value={asData.as_type} />
              </FlexRow>
              <FlexRow>
                <label>접수일</label>
                <input type="text" value={formattedDateTime(asData.create_date)} />
              </FlexRow>
              <FlexRow>
                <label>설치 위치</label>
                <input type="text" value={asData.reg_name} />
              </FlexRow>
              <FlexRow>
                <label>모델</label>
                <input type="text" value={asData.model} />
              </FlexRow>
              <FlexRow>
                <label>접수 제목</label>
                <input type="text" value={asData.title} />
              </FlexRow>
              <FlexRow>
                <label>접수 내용</label>
                <span>{asData.content}</span>
              </FlexRow>
            </div>
          </div>
          <div className="info_wrap">
            <div className="info_title">
              <h4>2. 내 정보 및 답변 정보</h4>
            </div>
            <div className="info_content readonly_info">
              <FlexRow>
                <label>성명</label>
                <input type="text" value={asData.user_name} />
              </FlexRow>
              <FlexRow>
                <label>아이디</label>
                <input type="text" value={asData.user_id} />
              </FlexRow>
              <FlexRow>
                <label>답변 방법</label>
                <input type="text" value={asData.answer_type} />
              </FlexRow>
              {asData.answer_type === "Mobile" ? 
                <FlexRow>
                  <label>답변 받을 연락처</label>
                  <input type="text" value={asData.user_mobile} />
                </FlexRow>
                :
                <FlexRow>
                  <label>이메일</label>
                  <input type="text" value={asData.user_email} />
                </FlexRow>
              }
              {asData.answer &&
                <>
                  <FlexRow>
                    <label>답변 내용</label>
                    <span>{asData.answer.content}</span>
                  </FlexRow>
                </>
              }
            </div>
          </div>
          {asData.state === 0 ?
            <div className="button_wrap">
              <FlexRow>
                <PrimaryButton type="button" onClick={() => navigate(`/user/after-service/create`, {state: asData})}>접수 수정</PrimaryButton>
                <OutlinePrimaryPinkButton type="button" onClick={cancelAfterService}>접수 취소</OutlinePrimaryPinkButton>
              </FlexRow>
            </div>
          :
            <div className="button_wrap">
              <FlexRow>
                <OutlinePrimaryPinkButton type="button" onClick={() => navigate("/user/after-service/list")}>돌아가기</OutlinePrimaryPinkButton>
              </FlexRow>
            </div>
          }
        </div>
      </div>
    </CreateSection>
  );
}